const createFishShape1 = shape => {
  shape.moveTo(32.6727, 30.742);
  shape.bezierCurveTo(33.4187, 30.4061, 34.108, 30.0858, 34.7675, 29.7668);
  shape.bezierCurveTo(35.6495, 29.3402, 36.1335, 28.6263, 36.2721, 27.8613);
  shape.bezierCurveTo(36.3966, 27.1745, 36.8911, 26.4483, 37.5889, 26.4335);
  shape.bezierCurveTo(46.274, 26.2491, 54.3985, 23.593, 61.7629, 19.6469);
  shape.bezierCurveTo(62.3953, 19.308, 62.6, 18.5041, 62.2192, 17.8961);
  shape.bezierCurveTo(61.9148, 17.4101, 61.9785, 16.7796, 62.3739, 16.3643);
  shape.lineTo(62.4053, 16.3313);
  shape.bezierCurveTo(62.871, 15.8423, 62.891, 15.0763, 62.4323, 14.5806);
  shape.bezierCurveTo(56.5774, 8.2535, 49.1844, 5.34047, 39.5016, 5.82021);
  shape.bezierCurveTo(38.5746, 5.86614, 37.6899, 4.404, 37.3705, 3.53262);
  shape.bezierCurveTo(37.2867, 3.30386, 37.1635, 3.08034, 36.9975, 2.86848);
  shape.bezierCurveTo(36.6164, 2.38233, 36.1948, 1.88475, 35.6958, 1.32544);
  shape.bezierCurveTo(35.5439, 1.15514, 35.358, 1.0112, 35.1333, 0.971359);
  shape.bezierCurveTo(34.5922, 0.875427, 34.1967, 1.41251, 34.0454, 1.94076);
  shape.bezierCurveTo(33.9638, 2.22546, 33.87, 2.47793, 33.7488, 2.74173);
  shape.bezierCurveTo(33.5738, 3.12254, 32.8604, 3.30512, 32.4413, 3.29675);
  shape.bezierCurveTo(31.9019, 3.28597, 31.8806, 3.74981, 31.9731, 4.28143);
  shape.lineTo(32.1336, 5.20385);
  shape.bezierCurveTo(32.2406, 5.81871, 31.9707, 6.77861, 31.3596, 6.90516);
  shape.bezierCurveTo(30.3906, 7.10581, 29.4022, 7.33302, 28.3937, 7.58678);
  shape.bezierCurveTo(27.8038, 7.73521, 27.0233, 6.90976, 26.5962, 6.47663);
  shape.bezierCurveTo(26.2333, 6.10857, 25.6823, 5.99696, 25.2069, 6.19971);
  shape.bezierCurveTo(21.8003, 7.65244, 19.7728, 8.78197, 16.5804, 10.8879);
  shape.bezierCurveTo(16.464, 10.9646, 16.393, 11.0955, 16.393, 11.2349);
  shape.bezierCurveTo(16.393, 11.3528, 16.3498, 11.4901, 16.2361, 11.5214);
  shape.bezierCurveTo(15.1914, 11.8091, 14.0645, 11.5095, 13.1669, 10.872);
  shape.bezierCurveTo(12.1947, 10.1817, 11.2266, 9.75171, 10.1372, 9.38366);
  shape.bezierCurveTo(8.26688, 8.75175, 6.24513, 10.2247, 6.57352, 12.1713);
  shape.bezierCurveTo(6.61007, 12.3881, 6.65218, 12.6066, 6.70039, 12.8289);
  shape.bezierCurveTo(7.0893, 14.6227, 6.10607, 16.4596, 4.368, 17.0494);
  shape.bezierCurveTo(3.05482, 17.4951, 1.94177, 18.0338, 0.595613, 18.8346);
  shape.bezierCurveTo(0.400965, 18.9504, 0.243219, 19.1198, 0.139105, 19.321);
  shape.bezierCurveTo(-0.248232, 20.0692, 0.211687, 20.977, 1.04414, 21.1073);
  shape.lineTo(2.61756, 21.3536);
  shape.bezierCurveTo(2.87301, 21.3936, 3.13379, 21.3911, 3.38896, 21.3494);
  shape.bezierCurveTo(4.27591, 21.2044, 5.06586, 21.099, 5.80961, 20.9997);
  shape.bezierCurveTo(7.49407, 20.7749, 8.94166, 20.5818, 10.7427, 20.0318);
  shape.bezierCurveTo(11.5888, 19.7735, 12.5112, 19.8437, 13.2899, 20.2633);
  shape.bezierCurveTo(15.517, 21.4634, 17.7231, 22.4708, 19.9057, 23.3009);
  shape.bezierCurveTo(20.1119, 23.3794, 20.1599, 23.6589, 20.0287, 23.8363);
  shape.bezierCurveTo(19.3198, 24.795, 19.6802, 26.1282, 20.7554, 26.6435);
  shape.bezierCurveTo(23.643, 28.0275, 26.0804, 29.1087, 30.3864, 30.7953);
  shape.bezierCurveTo(31.1248, 31.0846, 31.9496, 31.0676, 32.6727, 30.742);

  return shape;
};

export default createFishShape1;
